import { render } from "./event5.vue?vue&type=template&id=104ee9a3&scoped=true"
import script from "./event5.vue?vue&type=script&lang=js"
export * from "./event5.vue?vue&type=script&lang=js"

import exportComponent from "D:\\myWorkspace\\CoreServiceAzure\\CoreServiceCloud\\MyNews\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104ee9a3"]])

export default __exports__